var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9391 105.139V149.716H127.184V105.139H21.9391Z",
    fill: "#4D5E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5615 105.139H127.184V149.716H74.5615V105.139Z",
    fill: "#3D4566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1763 110.249H78.9467V123.405H70.1763V110.249Z",
    fill: "#FFDF40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5615 110.249H78.9467V123.405H74.5615V110.249Z",
    fill: "#FFBE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4875 75.1678H87.7171V64.8863C84.7799 63.7245 79.5971 62.0122 74.5615 62.0122C69.527 62.0122 64.3451 63.7236 61.4059 64.8866V75.1678H52.6355V59.3019L55.0596 58.0898C55.4555 57.8919 64.8673 53.2418 74.5615 53.2418C84.2557 53.2418 93.6675 57.8919 94.0633 58.0898L96.4875 59.3019V75.1678Z",
    fill: "#4D5E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7171 64.8863V75.1678H96.4875V59.3019L94.0634 58.0898C93.6675 57.8919 84.2557 53.2418 74.5615 53.2418V62.0122C79.5972 62.0122 84.7799 63.7245 87.7171 64.8863Z",
    fill: "#3D4566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.184 70.7826V105.139L74.5614 114.708L21.9391 105.139V70.7826H127.184Z",
    fill: "#3D4566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.184 70.7826H74.5615V114.708L127.184 105.139V70.7826Z",
    fill: "#2E2E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3064 62.8562L23.6748 58.2755L9.04315 62.8562L8.87827 47.5253L0 35.0251L14.5299 30.1307L23.6748 17.8247L32.8197 30.1307L47.3496 35.0251L38.4716 47.5253L38.3064 62.8562ZM59.9298 45.3154L59.765 29.9845L50.887 17.4844L65.4169 12.5899L74.5618 0.283875L83.7064 12.5899L98.2363 17.4844L89.3583 29.9845L89.1937 45.3157L74.5618 40.735L59.9298 45.3154ZM140.957 62.8562L126.325 58.2755L111.693 62.8562L111.529 47.525L102.651 35.0249L117.181 30.1304L126.325 17.8244L135.47 30.1304L150 35.0249L141.121 47.525L140.957 62.8562Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1935 45.3155L89.3581 29.9842L98.236 17.4844L83.7061 12.5899L74.5615 0.283875V40.7347L89.1935 45.3155ZM140.957 62.8562L141.122 47.5253L150 35.0251L135.47 30.1307L126.325 17.8247V58.2755L140.957 62.8562ZM38.3065 62.8562L38.4714 47.5253L47.3494 35.0251L32.8194 30.1307L23.6746 17.8247V58.2755L38.3065 62.8562Z",
    fill: "#FFBE40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/Expertise.bb2002a97541cb84f3e6553b70086c56.svg";
export { ForwardRef as ReactComponent };